import { useState } from 'react';
import { Link } from 'react-router-dom';
import { HexLockup } from '../../../components/FieldCertLogo';
import toast from 'react-hot-toast';
import api from '../../../lib/api';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';
import { Spinner } from '../../../components/ui/auth/AuthIcons';

function CheckIcon() {
  return (
    <svg className="login-success-icon" width="48" height="48" viewBox="0 0 56 56" fill="none" aria-hidden="true">
      <circle cx="28" cy="28" r="26" fill="rgba(45,184,90,0.15)" stroke="#2db85a" strokeWidth="2" /> {/* check-rules:ignore — success-icon stroke; SVG-local brand color */}
      <polyline points="16,28 23,36 40,19" stroke="#2db85a" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" fill="none" /> {/* check-rules:ignore — success-icon stroke; SVG-local brand color */}
    </svg>
  );
}

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [errors, setErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) {
      setErrors({ email: 'Email required' });
      return;
    }
    if (!email.includes('@')) {
      setErrors({ email: 'Invalid email address' });
      return;
    }
    setErrors({});
    setSending(true);
    try {
      await api.post('/auth/forgot-password', { email: email.trim() });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.error || 'Failed to send reset link');
    } finally {
      setSending(false);
    }
  };

  return (
    <div className="login-shell login-shell--auth-only">
      <div className="login-shell-bg" aria-hidden="true" />

      <div className="login-auth-panel">
        <div className="login-auth-inner">
          <div className="login-auth-brand">
            <HexLockup iconSize={48} wmSize="sm" gap={12} />
          </div>

          <div className="login-card">
            {sent ? (
              <div style={{
                display: 'flex', flexDirection: 'column', alignItems: 'center',
                gap: '0.875rem', padding: '0.5rem 0',
              }}>
                <CheckIcon />
                <h1 className="login-card-heading" style={{ textAlign: 'center' }}>
                  Check your inbox
                </h1>
                <p className="login-card-lead" style={{ textAlign: 'center', marginBottom: 0 }}>
                  Reset link sent to<br />
                  <span style={{ color: 'var(--brand-primary)' }}>{email}</span>
                </p>
                <Link to="/login" className="login-forgot-link" style={{ marginTop: '0.5rem' }}>
                  Back to sign in
                </Link>
              </div>
            ) : (
              <>
                <h1 className="login-card-heading">Reset password</h1>
                <p className="login-card-lead">
                  Enter your work email and we&rsquo;ll send a reset link.
                </p>

                <form onSubmit={handleSubmit} className="login-form" noValidate>
                  <Input
                    label={errors.email || 'Email'}
                    error={!!errors.email}
                    id="forgot-email"
                    type="email"
                    value={email}
                    onChange={(e) => {
                      setEmail(e.target.value);
                      if (errors.email) setErrors({});
                    }}
                    required
                    autoComplete="email"
                    placeholder="you@company.com.au"
                    disabled={sending}
                  />
                  <Button type="submit" variant="primary" className="login-cta" disabled={sending}>
                    {sending ? <><Spinner /> Sending…</> : 'Send Reset Link'}
                  </Button>
                </form>

                <p className="login-card-back">
                  <Link to="/login">Back to sign in</Link>
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
